import {Link} from 'react-router-dom'

const DashboardsPage = () => {
  return (
    <>
      <div style={{minHeight: "80vh", display:"flex", alignItems:"center", justifyItems:"center", overflowY:'hidden'}} className='row bg-light'>
        <div className='col-xl-1'>
        </div>
        <div className='col-xl-2'>
          <div style={{marginBottom:"10px" , textAlign:"center"}}>
            <img src='media/reports-logos/accnt.svg' width='200px' height="100px" />
          </div>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-body p-5'>
              <div className=''>
                <div style={{textAlign:"center"}} className='d-flex align-items-center flex-column'>
                  <Link
                    to={'#'}
                    className='text-gray-900 text-hover-primary fs-6 fw-bold'
                  >
                   FINANCE
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-xl-2'>
        <div style={{marginBottom:"10px" , textAlign:"center"}}>
            <img src='media/reports-logos/service.svg' width='200px' height="100px" />
          </div>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-body p-5'>
              <div>
                <div style={{textAlign:"center"}} className='d-flex flex-column'>
                  <Link
                    to={'#'}
                    className='text-gray-900 text-hover-primary fs-6 fw-bold'
                  >
                    PROJECTS
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-xl-2'>
        <div style={{marginBottom:"10px" , textAlign:"center"}}>
            <img src='media/reports-logos/mine.svg' width='200px' height="100px" />
          </div>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-body p-5'>
              <div>
                <div style={{textAlign:"center"}} className='d-flex flex-column'>
                  <Link
                    to={'#'}
                    className='text-gray-900 text-hover-primary fs-6 fw-bold'
                  >
                    INVENTORY
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-xl-2'>
        <div style={{marginBottom:"10px" , textAlign:"center"}}>
            <img src='media/reports-logos/production.svg' width='200px' height="100px" />
          </div>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-body p-5'>
              <div>
                <div style={{textAlign:"center"}} className='d-flex flex-column'>
                  <Link
                    to={'#'}
                    className='text-gray-900 text-hover-primary fs-6 fw-bold'
                  >
                    CONTRACTOR PORTAL
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  className='col-xl-2'>
        <div style={{marginBottom:"10px" , textAlign:"center"}}>
            <img src='media/reports-logos/user.svg' width='200px' height="100px" />
          </div>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-body p-5'>
              <div>
                <div style={{textAlign:"center"}} className='d-flex flex-column'>
                  <Link
                    to={'#'}
                    className='text-gray-900 text-hover-primary fs-6 fw-bold'
                  >
                    HR PAYROLL
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardsPage;